import { gateway } from "../../../../../../../../gateway";
import dayjs from "dayjs";

export interface PunchPayload {
  jobEventUid: string;
  action: "start" | "end";
}

export interface PunchResponse {
  data: {
    startAt?: string;
    endAt?: string;
  };
}

export const punchJobAction = async ({ jobEventUid, action }: PunchPayload, token: string) => {
  const res = await gateway.put<PunchResponse>(
    `/jobs/event/punch`,
    { jobEventUid, action },
    { headers: { Authorization: token } }
  );

  const { startAt, endAt } = res.data.data;

  return action === "start"
    ? dayjs(startAt || dayjs())
    : dayjs(endAt || dayjs());
};
